import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';

type PhoneStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

interface PhoneData {
  status: PhoneStatus;
}

function getState(listingData: PhoneData[], hasPendingData: boolean, isTransacted: boolean): string {
  if (listingData.length > 0) {
    if (!isTransacted) return 'registered';
    if (hasPendingData) return 'pending';
    return 'approved';
  }
  return 'empty';
}

function logCommonPhonePage(
  e: { name: string; attributes: Record<string, string> },
  eventSource: string,
  data: PhoneData[],
  hasPendings: boolean,
  isTransact: boolean,
  transactionCategoryId?: string | number | null,
): void {
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: eventSource,
    [e.attributes.state]: getState(data, hasPendings, isTransact),
    [e.attributes.transaction_category_id]: transactionCategoryId ?? null,
  });
}

function logPhonePage(
  eventSource: string,
  data: PhoneData[],
  isTransact: boolean,
  transactionCategoryId?: string | number | null,
): void {
  const hasPendings = data?.filter(item => item.status === 'PENDING')?.length > 0;
  logCommonPhonePage(
    AMPLITUDE_CONSTANTS.PhoneEnroll.phone_list_page,
    eventSource,
    data,
    hasPendings,
    isTransact,
    transactionCategoryId,
  );

  if (isTransact) {
    logCommonPhonePage(
      AMPLITUDE_CONSTANTS.PhoneEnroll.select_phone_page,
      eventSource,
      data,
      hasPendings,
      isTransact,
      transactionCategoryId,
    );
  }
}

export default logPhonePage;
